import React from 'react'
import { Button, StopsCard } from '../../../components'
import { images } from '../../../images'
import { IFavoriteResponse } from '../../../models'
import { LiteralsService } from '../../../services'
import StyledSection from './styles'
import moment from 'moment'

interface IProps {
  favorite: IFavoriteResponse
  onClick: () => void
  onRepeat: (favorite: IFavoriteResponse) => void
}

export const Card: React.FC<IProps> = ({ favorite, onClick, onRepeat }) => {
  return (
    <StyledSection>
      <header>
        <h4>
          { favorite.name }
          <button onClick={ onClick }>
            <img
              src={ images['starSelected']}
              alt="Star Selected"
              style={{ zIndex: 10, width: '20px', height: '20px' }}
            />
          </button>
        </h4>
        <Button
          onPress={ () => onRepeat(favorite) }
          title={ LiteralsService.get('rebook', true) }
          styles={{ width: '180px' }}
          filled
          upper
        />
      </header>
      <section className="content">
        <div className="details">
          <header>
            <span className="date">
              { moment(favorite.time, 'HH:mm:ss').format('HH:mm') }
            </span>
          </header>
          <div>
            <StopsCard
              inStopName={ favorite.inStop.properties.name }
              outStopName={ favorite.exitStop.properties.name }
            />
          </div>
        </div>
      </section>
    </StyledSection>
  )
}
